import { useCallback, useState } from 'react';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { State } from './types';
import { getUrl } from './utils';

export const useParseIcsService = (baseUrl: BaseUrl): State => {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<unknown>(null);

	const parseIcsFile = useCallback(
		async (file: File) => {
			setLoading(true);
			setError(null);

			const formdata = new FormData();
			formdata.append('file', file, file.name);
			let data;
			try {
				const rawResponse = await fetch(getUrl(baseUrl), {
					body: formdata,
					headers: { credentials: 'same-origin' },
					method: 'POST',
				});
				const textResponse = await rawResponse.text();
				data = textResponse ? JSON.parse(textResponse) : null;
			} catch (e) {
				setError(e);
			}

			setLoading(false);
			return data;
		},
		[baseUrl],
	);
	return [
		{
			loading,
			error,
		},
		{
			parseIcsFile,
		},
	];
};
